import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ChartLegendItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    offLabel: {
        textDecorationLine: "line-through"
    },
    container: {
        justifyContent: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        alignItems: "center",
        flexDirection: "row"
    },
    plain: {
        alignItems: "center",
        flexDirection: "row"
    },
    label: {
        flexShrink: 1
    }
});

export const useStyles = ({
    controlHeights,
    isFocusVisible,
    isToggleable,
    shapeConfigs,
    touchTargets,
    pointerType,
    radiuses,
    borders,
    colors,
    spaces
}: ChartLegendItemDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: controlHeights.small,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            paddingHorizontal: spaces.spacingSm,
            minHeight: controlHeights.small,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            gap: spaces.spacingSm,
            ...getFocusRingStyle({
                isFocusVisible,
                isInset: true,
                borders,
                colors
            })
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight
        } as Mutable<ViewStyle>,
        plain: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(!isToggleable) {
        delete styles.surface.paddingHorizontal;
    }

    return styles;
};
export default stylesheet;
